import { Dispatch, SetStateAction, useState } from 'react';

export function useCitySelected<T = string>(
  initialState?: T,
): [T | undefined, Dispatch<SetStateAction<T | undefined>>] {
  return useState<T | undefined>(initialState);
}
